import { render, staticRenderFns } from "./SettingsGlobal.vue?vue&type=template&id=2e8d00c0&"
import script from "./SettingsGlobal.vue?vue&type=script&lang=js&"
export * from "./SettingsGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports